import {createActions} from 'client/framework';

const normalActions = [
  'TOGGLE_CLASSROOM_STATUS',
  'TOGGLE_EXPAND_SUBJECTS',
  'TOGGLE_EXPAND_TEACHERS',
  'RESET_STORE'
];

export default createActions(null, normalActions);
